export default __webpack_public_path__ + "static/media/10_bees_icon.62d5b6c2.png";